import React, { memo } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Backdrop } from '@mui/material';

const ModalHeader = memo(({ children }) => (
  <div variant="h5" sx={{ mb: 0 }}>
    {children}
  </div>
));

const ModalBody = memo(({ children }) => (
  <Box variant="body" className="noScrollBar" sx={{ mb: 0, maxHeight: '90vh', overflow: 'scroll' }}>
    {children}
  </Box>
));

const ModalFooter = memo(({ children, onClose }) => (
  <div style={{ boxShadow: '0px 25px 57px rgba(0, 0, 0, 0.5)' }} varient="footer">
    {children}
  </div>
));

const CustomModal = memo(({ open, onClose, children, sx = {} }) => (
  <Modal
    className="noTableCellBorder"
    id={open ? 'ModalWhileSave' : ''}
    open={open}
    onClose={onClose}
    sx={sx}
    closeAfterTransition
    disableRestoreFocus
    BackdropComponent={Backdrop}
    BackdropProps={{
      timeout: 500,
    }}
    closeTimeout={500}
    closeTransitionDuration={500}
  >
    <Box
      sx={{
        display: 'flex',
        '@media (min-width:600px)': {
          width: 'auto',
        },
        width: '90%',
        flexDirection: 'column',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        maxHeight: '95vh',
        overflow: 'hidden',
      }}
    >
      {children}
    </Box>
  </Modal>
));

CustomModal.Header = ModalHeader;
CustomModal.Body = ModalBody;
CustomModal.Footer = ModalFooter;

export { CustomModal as Modal };
